import { defineStore } from 'pinia'
import { ref } from 'vue'
import { ProcessingVariableEnum } from '../../../../@core/processing/domain/enums/ProcessingVariable.enum'
import { ProcessingResolutionEnum } from '../../../../@core/processing/domain/enums/ProcessingResolution.enum'

export interface SmartProcessingFormData {
	measurementId: string
	farmId: string
	description: string
	significanceLevel: number
	stumpHeight: number
	officialInventory: boolean
	processingVariables: ProcessingVariableEnum[]
	resolution: ProcessingResolutionEnum
	volumeInventoryStratumId: string
	aggregatingVariables: string
	selectedProductIds: string[]
	associatePrognosis: boolean
	prognosisId: string
	projectionHorizon: number | null
}

export const useSmartProcessingStore = defineStore('smart-processing', () => {
	const measurementId = ref('')
	const farmId = ref('')
	const description = ref('')
	const significanceLevel = ref(0.05)
	const stumpHeight = ref(0.1)
	const officialInventory = ref(true)
	const processingVariables = ref<ProcessingVariableEnum[]>([])
	const resolution = ref<ProcessingResolutionEnum>(ProcessingResolutionEnum.MEDIUM)
	const volumeInventoryStratumId = ref('')
	const aggregatingVariables = ref('')
	const selectedProductIds = ref<string[]>([])
	const associatePrognosis = ref(false)
	const prognosisId = ref('')
	const projectionHorizon = ref<number | null>(null)
	const selectedImageIds = ref<string[]>([])
	const justReturnedFromImageSelection = ref(false)

	function populateFromForm(data: SmartProcessingFormData) {
		measurementId.value = data.measurementId
		farmId.value = data.farmId
		description.value = data.description
		significanceLevel.value = data.significanceLevel
		stumpHeight.value = data.stumpHeight
		officialInventory.value = data.officialInventory
		processingVariables.value = data.processingVariables
		resolution.value = data.resolution
		volumeInventoryStratumId.value = data.volumeInventoryStratumId
		aggregatingVariables.value = data.aggregatingVariables
		selectedProductIds.value = data.selectedProductIds
		associatePrognosis.value = data.associatePrognosis
		prognosisId.value = data.prognosisId
		projectionHorizon.value = data.projectionHorizon
		selectedImageIds.value = []
	}

	function setSelectedImages(ids: string[]) {
		selectedImageIds.value = ids
		justReturnedFromImageSelection.value = true
	}

	function clearReturnFlag() {
		justReturnedFromImageSelection.value = false
	}

	function reset() {
		measurementId.value = ''
		farmId.value = ''
		description.value = ''
		significanceLevel.value = 0.05
		stumpHeight.value = 0.1
		officialInventory.value = true
		processingVariables.value = []
		resolution.value = ProcessingResolutionEnum.MEDIUM
		volumeInventoryStratumId.value = ''
		aggregatingVariables.value = ''
		selectedProductIds.value = []
		associatePrognosis.value = false
		prognosisId.value = ''
		projectionHorizon.value = null
		selectedImageIds.value = []
		justReturnedFromImageSelection.value = false
	}

	return {
		measurementId,
		farmId,
		description,
		significanceLevel,
		stumpHeight,
		officialInventory,
		processingVariables,
		resolution,
		volumeInventoryStratumId,
		aggregatingVariables,
		selectedProductIds,
		associatePrognosis,
		prognosisId,
		projectionHorizon,
		selectedImageIds,
		justReturnedFromImageSelection,
		populateFromForm,
		setSelectedImages,
		clearReturnFlag,
		reset,
	}
})
